import { useEffect } from 'react';
import { useQuery } from '@apollo/client/react';

import {
    IPortfolioItemMatrixFragment,
    ISkillPortfolioReportQueryVariables,
    SkillPortfolioReportDocument,
} from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

interface IProps {
    queryVariables: ISkillPortfolioReportQueryVariables;
    skip?: boolean;
}

export const useSkillReportList = ({
    queryVariables,
    skip = false,
}: IProps) => {
    const { showApolloError } = useApolloError();

    const { loading, data, refetch, error } = useQuery(
        SkillPortfolioReportDocument,
        {
            variables: queryVariables,
            skip,
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
        }
    );

    useEffect(() => {
        if (error) {
            showApolloError(error);
        }
    }, [error, showApolloError]);

    const items = (data?.skillPortfolioReport ||
        []) as IPortfolioItemMatrixFragment[];

    return {
        items,
        loading,
        refetch,
    };
};
